import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

import { useNavLoadingBar } from '@/hooks/useNavLoadingBar'

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})

interface RouterContext {
  queryClient: QueryClient
}

function RootComponent() {
  useNavLoadingBar();

  return <Outlet />
}
